const checkForum = setInterval(() => {
  const forumAppWrapper = document.querySelector('.shopify-app-block');
  forumAppWrapper.style.setProperty('max-width', '585px');
  forumAppWrapper.style.setProperty('width', '100%');
  const app = document.getElementById('app-embed');
  const shadowRoot = app?.shadowRoot;
  if (shadowRoot && shadowRoot.getElementById('form-container-ref')) {
    clearInterval(checkForum);
    const appRouter = shadowRoot.querySelector('[data-testid="app-router"]');
    appRouter?.style.setProperty('grid-template-columns', '1fr');
    const shoppablesRoot = shadowRoot.getElementById('form-container-ref');
    const formWrapper = shoppablesRoot.querySelector('[data-sizing="form-wrapper"]');
    formWrapper.style.setProperty('max-width', '585px', 'important');
    const gridForumWrapper = formWrapper.querySelector('form');
    const allInfos = gridForumWrapper.querySelectorAll('._formFieldContainer_1mxsl_5');
    allInfos.forEach((info, i) => {
      const description = info.querySelector('._formInputFieldLabel_1mxsl_38');
      const infoInput = info.querySelector('._formInputField_nag3b_7');
      if(infoInput) {
        infoInput?.style.setProperty('background-color', 'transparent', 'important');
        infoInput?.style.setProperty('border-bottom', '1px solid #D9D9D9');
        infoInput?.style.setProperty('border-radius', '0');
        infoInput?.style.setProperty('color', 'white');
      }
      if( i == 0 ) {
        description?.style.setProperty('color', '#112D77');
      } else {
        description?.style.setProperty('color', '#9D9D9D');
      }
    })

    const privacy = gridForumWrapper.querySelector('._formSubmitButton_cit2d_96');
    privacy?.style.setProperty('background-color', '#716E6A', 'important');
    privacy?.style.setProperty('width', '50%');
    const isMobile = window.matchMedia('(max-width: 767px)').matches; 
    if(isMobile) {
      privacy?.style.setProperty('margin', '0 auto');
      const formPolicy = formWrapper.querySelector('._formDisclaimer_cit2d_38');
      formPolicy?.style.setProperty('text-align', 'center');
    }

  }
}, 500);

setTimeout(() => {
  clearInterval(checkForum);
}, 10000);